export { HomePage } from './home';
export { LogInPage } from './login';
// export { ListCustomer } from './listCustomer';
export { BulkImport } from './bulkImport';
export { Customer } from './Customer';
// export { ListMeetingRoom } from './listMeetingRoom';
export { MeetingNote } from './MeetingNote';
// export { AddMultipleMeeting } from './addMultipleMinuteNote';
// export { ViewMeeting } from './viewMeetingMin';
// export { EditMeeting } from './editMeetingMin';
export { Dashboard } from './dashboard';
export { Calendar } from './calendar';
export { Communication } from './communication';
export { Chat } from './chat';
export { Style } from './Style';
export { CreateIB } from './createIB';
export { Smv_Ov_List } from './listSMV';
export { SmvThread } from './SmvThread';
// export { ListThreadConsumption } from './listThreadConsumption';
export { TechnicalIssues } from './technicalIssues';
// export { ListSample } from './listSample';
// export { AddNewSample } from './addNewSample';
// export { CostList } from './listCosting';
// export { ViewCost } from './viewCost';
// export { EditCost } from './editCost';
// export { ListPermissionsRole } from './listPermissionRole';
export { PermissionRole } from './PermissionRole';
// export { ViewPermissionRole } from './viewPermissionRole';
export { DevelopmentCAD } from './developmentCAD';
export { DevelopmentSourcing } from './developmentSourcing';
export { DevelopmentProduct } from './developmentProduct';
export { DevelopmentFabric } from './developmentFabric';
// export { ListDevelopmentTrim } from './listDevelopmentTrim';
// export { ListIB } from './listIB';
// export { ListDevelopmentCAD } from './listDevelopmentCAD';
// export { ListDevelopmentBNumber } from './listDevelopmentBNumber';
// export { EditCAD } from './editCAD';
// export { ViewCAD } from './viewCAD';
// export { ListDevelopmentProduct } from './listDevelopmentProduct';
// export { ListDevelopmentSourcing } from './listDevelopmentSourcing';
export { DevelopmentBNumber } from './developmentBNumber';
// export { ViewBNumber } from './viewBNumber';
// export { EditBNumber } from './editBNumber'; 
export { EmployeRights } from './employeRights';
export { Employee } from './Employee';
export { SystemSubmodulesPage } from './systemSubModules';
export { SystemCategoryList } from './systemCategoryList';
export { AddCategory } from './systemAddCategory';

export { Costing } from './Costing';
export { CostingComparison } from './CostingComparison'
// export { ViewSourcing } from './viewSourcing';
// export { EditSourcing } from './editSourcing';
// export { ViewProduct } from './viewProduct';
// export { EditProduct } from './editProduct';
// export { ViewTrim } from './viewTrim';
// export { EditTrim } from './editTrim';
// export { ViewDevelopmentProduct } from './viewDevelopmentProduct';
// export { EditDevelopmentProduct } from './editDevelopmentProduct';
// export { ViewSMV } from './viewSMV';
// export { EditSMV } from './editSMV';
// export { ListEmbroidery } from './listEmbroidery';
// export { AddEmbroidery } from './addEmbroidery';
// export { ViewEmbroidery } from './viewEmbroidery';
// export { EditEmbroidery } from './editEmbroidery';
// export { ViewThread } from './viewThreadConsumption';
// export { EditThread } from './editThreadConsumption';
export { GenerateTag } from './generateTag';
// export { ViewStyle } from './viewStyle';
// export { EditStyle } from './editStyle';
// export { ViewSample } from './viewSample';
// export { EditSample } from './editSample';
// export { NewCost } from './newCostPage';
//PRINT FABRIC NUMBER
export { PrintFabricNumber } from './printFabricNumber';
//Profile
export { Profile } from './Profile'

// Page not Found
export { PageNotFound } from './pageNotFound';

//List for all modules
export { List } from './list';

//Trim
export { Trim } from './Trim';

//Sample
export { Sample } from './Sample'

//SystemSupplier
export { SystemSupplier } from './systemSupplier';

//fabricReport 
export { Report } from './report';


// WEBPACK FOOTER //
// ./src/pages/index.js